// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__ff0m5","item":"index_item__USJrX","selected":"index_selected__fV9qy","selected-text":"index_selected-text__tkuyB"};